import _ from "lodash";
import {
  clearAuthSession,
  getAuthToken,
  isAuthTokenExpired,
} from "../auth/authStorage";

let responeInfo;

const send = async (url, auth, reqType = "GET", body = "", responseType = "json") => {
  const token = getAuthToken();

  let requestContent;
  if (_.isEmpty(auth)) {
    auth = token;
  }

  const isAuthenticatedRequest = auth !== "noAuth" && auth !== "exact";
  if (isAuthenticatedRequest) {
    if (_.isEmpty(auth)) {
      clearAuthSession();
      return Promise.reject({ status: 401 });
    }

    const parsedToken = _.startsWith(auth, "Bearer ") ? auth.slice(7) : auth;
    if (isAuthTokenExpired(parsedToken)) {
      clearAuthSession();
      return Promise.reject({ status: 401 });
    }
  }

  if (auth === "noAuth") {
    requestContent = {
      method: reqType,
    };
  } else if (auth === "exact") {
    requestContent = {
      method: reqType,
      mode: 'no-cors',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
      },
    };
  } else {
    requestContent = {
      method: reqType,
      headers: {
        "Content-Type": "application/json",
        Authorization: _.startsWith(auth, "Bearer ") ? auth : `Bearer ${auth}`,
      },
    };
  }
  if (reqType === "POST") {
    requestContent.body = JSON.stringify(body);
  }
  return fetch(url, requestContent)
    .then((response) => {
      const responseContentType = response.headers.get("Content-Type");
      if (!response.ok) {
        if (response.status === 401) {
          if (isAuthenticatedRequest) {
            clearAuthSession();
          }
          return Promise.reject({
            status: 401,
          });
        }
        if (
          response.status === 400 ||
          response.status === 500 ||
          (responseContentType &&
            responseContentType.includes("application/json"))
        ) {
          return Promise.reject(response);
        }
      }
      responeInfo = response;
      return responseType === "blob" ? response.blob() : response.json();
    })
    .then((data) => {
      return {
        info: responeInfo,
        data: data,
      };
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
// eslint-disable-next-line import/no-anonymous-default-export
export default { send };
